import { GlobalConstants } from '../../common/constants/global.constant';

export const factTagsEnum = {
  processor : GlobalConstants.FACTTAGS_PROCESSOR,
   oem : GlobalConstants.FACTTAGS_OEM,
    optane_memory : GlobalConstants.FACTTAGS_INTEL_OPTANE_MEMORY,
    display : GlobalConstants.FACTTAGS_SCREEN,
    battery : GlobalConstants.FACTTAGS_BATTERY_LIFE,
    storage : GlobalConstants.FACTTAGS_STORAGE,
    memory : GlobalConstants.FACTTAGS_MEMORY_OPTANE_MESSAGING,
    camera : GlobalConstants.FACTTAGS_CAMERA,
    graphics : GlobalConstants.FACTTAGS_GRAPHICS,
    wifi : GlobalConstants.FACTTAGS_WIFI,
    vr : GlobalConstants.FACTTAGS_VR,
    thunderbolt : GlobalConstants.FACTTAGS_THUNDERBOLT,
    device_type : GlobalConstants.FACTTAGS_DEVICE_TYPE,
    operating_system : GlobalConstants.FACTTAGS_OS
  };
